var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortlisted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3.25H14.82C14.4 2.09 13.3 1.25 12 1.25C10.7 1.25 9.6 2.09 9.18 3.25H5C3.9 3.25 3 4.15 3 5.25V19.25C3 20.35 3.9 21.25 5 21.25H19C20.1 21.25 21 20.35 21 19.25V5.25C21 4.15 20.1 3.25 19 3.25ZM12 3.25C12.55 3.25 13 3.7 13 4.25C13 4.8 12.55 5.25 12 5.25C11.45 5.25 11 4.8 11 4.25C11 3.7 11.45 3.25 12 3.25ZM12 7.25C13.66 7.25 15 8.59 15 10.25C15 11.91 13.66 13.25 12 13.25C10.34 13.25 9 11.91 9 10.25C9 8.59 10.34 7.25 12 7.25ZM18 19.25H6V17.85C6 15.85 10 14.75 12 14.75C14 14.75 18 15.85 18 17.85V19.25Z",
    fill: "#576EDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortlisted);
export default __webpack_public_path__ + "static/media/shortlisted.935ddbb77797f79b9b223034cfc18564.svg";
export { ForwardRef as ReactComponent };